import { AssetType, NETWORK_CONFIG } from ".."

export const isNative=(asset:AssetType)=>{
    return !!asset.native
}
export const isAddressNative=(address:string,chainId:string)=>{
    return NETWORK_CONFIG[chainId].native===address ;
}
export const isReserveAsset=(asset:AssetType)=>{
    return !(asset.resourceId==="")
}